import { useQuery } from '@tanstack/react-query';
import { queryKey } from '../constant/queryKey';
import { goodsService } from 'shared/src/api/goodsService';
import { useGoodsSno } from '../hooks/useGoodsSno';

export const useGoodsDiscounts = () => {
  const goodsSno = useGoodsSno();
  return useQuery({
    queryKey: queryKey.goodsDiscount(goodsSno),
    queryFn: () => goodsService.getGoodsDiscounts(goodsSno),
  });
};
